module.exports = __webpack_public_path__ + "components/home-header/static/header-3--small-11357e8d3db484bcdd5614ab6be3f879.jpg";